import { useState } from 'react';
import {
  LOGIN_FORM_TYPES,
  LOGIN_STEPS,
  USER_STATUS,
} from '../../appContants.js';

/**
 * Manages the login step state machine.
 * Tracks which step the user is on (EMAIL → PASSWORD → OTP / RESET_PASSWORD),
 * the entered email, and the resolved user status.
 */
const useLoginSteps = () => {
  const [currentStep, setCurrentStep] = useState(LOGIN_STEPS.EMAIL);
  const [email, setEmail] = useState('');
  const [userStatus, setUserStatus] = useState(null);

  const goToStep = (step, opts = {}) => {
    setCurrentStep(step);
    if (opts.email !== undefined) setEmail(opts.email);
    if (opts.userStatus !== undefined) setUserStatus(opts.userStatus);
  };

  const resetSteps = () => {
    setCurrentStep(LOGIN_STEPS.EMAIL);
    setEmail('');
    setUserStatus(null);
  };

  const getTitle = (cognitoChallenge) => {
    if (cognitoChallenge === LOGIN_FORM_TYPES.NEW_PASSWORD_REQUIRED) {
      return 'Update Password';
    }
    switch (currentStep) {
      case LOGIN_STEPS.PASSWORD:
        return userStatus === USER_STATUS.CONFIRMED ? 'Enter Password' : 'Login';
      case LOGIN_STEPS.RESET_PASSWORD:
        return userStatus ? 'Reset Password' : 'Login';
      case LOGIN_STEPS.OTP:
        return 'Verify OTP';
      default:
        return 'Login';
    }
  };

  return {
    currentStep,
    email,
    userStatus,
    goToStep,
    resetSteps,
    getTitle,
  };
};

export default useLoginSteps;
